// removed by extract-text-webpack-plugin
module.exports = {"player":"_2nmoa8ZkODQvjwsf-AL0CW","bg-player":"_3BH2PdBTfmHCSeuVNQQ9RO","bgPlayer":"_3BH2PdBTfmHCSeuVNQQ9RO"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/video/bgVideoPlayer.css
// module id = 379
// module chunks = 0